// src/components/AboutSection.jsx
import React from "react";
import NewsSectionTwo from "./NewsSectionTwo";
import ClientsSection from "./ClientsSection";
import ClientsSectiomn from "../pages/ClientsSectionn";

export default function About({
  subtitle = "Our story",
  title = "About Shree Swami Samarth PG:",
  paragraphs = [
    "Welcome to Shree Swami Samarth PG, where the essence of home meets the convenience of modern living. Nestled in the heart of pune, we take pride in offering more than just accommodation we provide a sanctuary for those seeking a comfortable and communal living experience.",
    "Established with a passion for creating a warm and inviting space, Shree Swami Samarth PG has become synonymous with quality living. We understand the significance of a place that not only meets your daily needs but also fosters a sense of belonging and connection.",
  ],

}) {
  return (


    <>
    <section
  className="page-title"
  style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
>
  <div className="auto-container">
    <h1>About Us</h1>
  </div>
</section>

     

    <section className="about-section">
      <div className="auto-container">
        <div className="row clearfix">
          <div className="content-column col-md-6 col-sm-12 col-xs-12">
            <div className="inner-column">
              <div className="sec-title style-two">
                <div className="sub-title">{subtitle}</div>
                <h2>{title}</h2>
                <div className="separator"></div>
              </div>
              <div className="text">
                {paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </div>
          </div>

          <div className="image-column col-md-6 col-sm-12 col-xs-12">
            <div className="image">
              <img src="./images/about-3.jpg" alt="About" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </section>
<NewsSectionTwo/>
<ClientsSectiomn/>
    </>
  );
}
